import { IPcr } from '../../../features/pcr/store/pcr.types'
import Logger from '../../../services/logger.service'
import { setValueForPathWithCreate } from '../../object.util'

export const createCompleteChart = (pcr: any): IPcr => {
  try {
    const completeChart = pcr?.completeChart
    if (!completeChart?.lockChart) {
      setValueForPathWithCreate(pcr, 'completeChart.lockChart', 0)
    }
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule createCompleteChart: ${error}`)
    throw error
  }
}
